<template>
  <div id="app" class="app">
    <router-view />

    <!-- 遮罩层 登陆 complexPassword -->
    <div class="logined-mask" v-if="isShowMask"></div>
    <vuestic-modal :show.sync="complexPassword"
                  ref="complexPassword"
                  :okText="'modal.confirm2' | translate"
                  style="height: 100%;width:60vw;"
                  :okClass="'btn btn-primary btn-micro'"
                  :cancelClass="'btn btn-secondary btn-micro'"
                  :cancelText="'modal.cancel2' | translate"
                  alignModal="change-password-show"
                  :force="true">
      <div slot="title">Please Change Password</div>
      <!-- <div slot="title">{{'modal.refundReason' | translate}}</div> -->
      <div>
        <form>
          <div class="va-row">
            <div class="flex xs12 md12">
              <fieldset>
                <div class="form-group with-icon-right"
                     :class="{'has-error': errors.has('currentPassword'), 'valid': isFormFieldValid('currentPassword')}">
                  <div class="input-group">
                    <input :type="isCurOpen?'text':'password'" autocomplete="off" maxlength="50" v-model="currentPassword" v-validate="'required'" required name="currentPassword" data-vv-as="Current Password" onkeyup="value=value.replace(/\s/g,'')" onkeydown="value=value.replace(/\s/g,'')" />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" for="currentPassword">{{'profile.cur_password' | translate}}：</label>
                    <i class="bar"></i>
                    <div class="login-eye-password">
                      <img :src="closeEye" alt="" @click="() => { isCurOpen = true }" v-if="!isCurOpen"/>
                      <img :src="openEye" alt="" @click="() => { isCurOpen = false }" v-if="isCurOpen"/>
                    </div>
                    <small v-show="errors.has('currentPassword')"
                           class="help text-danger">{{ errors.first('currentPassword') }}</small>
                  </div>
                </div>
                <div class="form-group with-icon-right"
                     :class="{'has-error': errors.has('newPassword'), 'valid': isFormFieldValid('newPassword')}">
                  <div class="input-group">
                    <input :type="isNewOpen?'text':'password'" autocomplete="off" maxlength="50" v-model="newPassword" v-validate="'required'" required name="newPassword" data-vv-as="New Password" onkeyup="value=value.replace(/\s/g,'')" onkeydown="value=value.replace(/\s/g,'')"  />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" for="newPassword">{{'profile.new_password' | translate}}：</label>
                    <i class="bar"></i>
                    <div class="login-eye-password">
                      <img :src="closeEye" alt="" @click="() => { isNewOpen = true }" v-if="!isNewOpen"/>
                      <img :src="openEye" alt="" @click="() => { isNewOpen = false }" v-if="isNewOpen"/>
                    </div>
                    <small v-show="errors.has('newPassword')"
                           class="help text-danger">{{ errors.first('newPassword') }}</small>
                  </div>
                </div>
                <div class="form-group with-icon-right" style="margin-bottom:0!important"
                     :class="{'has-error': errors.has('repeatNewPassword'), 'valid': isFormFieldValid('repeatNewPassword')}">
                  <div class="input-group">
                    <input :type="isRepOpen?'text':'password'" autocomplete="off" maxlength="50" v-model="repeatNewPassword" v-validate="'required'" required name="repeatNewPassword" data-vv-as="Repeat New Password" onkeyup="value=value.replace(/\s/g,'')" onkeydown="value=value.replace(/\s/g,'')"  />
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label" for="repeatNewPassword">{{'profile.repeat_password' | translate}}：</label>
                    <i class="bar"></i>
                    <div class="login-eye-password">
                      <img :src="closeEye" alt="" @click="() => { isRepOpen = true }" v-if="!isRepOpen"/>
                      <img :src="openEye" alt="" @click="() => { isRepOpen = false }" v-if="isRepOpen"/>
                    </div>
                    <small v-show="errors.has('repeatNewPassword')" class="help text-danger">{{ errors.first('repeatNewPassword') }}</small>
                    <div><small v-show="errorText" class="help text-danger" style="display: inline-block;text-align: justify;word-break: break-all;letter-spacing: 0.8px;">{{errorText}}</small></div>
                  </div>
                </div>
                <div class="form-group with-icon-right" style="margin-top:10px;">
                  {{ $t('t.newPasswordMustBe') }}
                </div>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
    </vuestic-modal>

    <multipleMerchant />
  </div>
</template>

<script>
import { request } from '@/utils/utils.js'
import multipleMerchant from "@/package/multipleMerchant.vue"
export default {
  name: "app",
  data() {
    return {
      complexPassword: true,
      currentPassword: '',
      newPassword: '',
      repeatNewPassword: '',
      token: localStorage.getItem('Authorization') || null,
      isShowMask: false,
      errorText: '',
      closeEye: require('@/assets/images/eye-close.png'),
      openEye: require('@/assets/images/eye-open.png'),
      isCurOpen: false,
      isNewOpen: false,
      isRepOpen: false
    }
  },
  watch: {
    $route (route) {
      let isEasyPassword = localStorage.getItem('isEasyPassword');
      if (eval(isEasyPassword) && route.path !== '/' && route.path !== '/auth/login') {
        this.init()
        this.$nextTick(() => {
          this.$refs.complexPassword.open()
          this.isShowMask = true
        })
      } else {
        this.isShowMask = false
        this.$refs.complexPassword.close()
      }
    },
  },
  mounted() {
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = require(`@/assets/images/${process.env.VUE_APP_WEBSETE_SIGN}Img/favicon.png`)
    document.getElementsByTagName('head')[0].appendChild(link);
    // 如果不是登陆页，且已经登陆；密码不符合要求显示遮罩层
    // console.log(JSON.stringify(this.$route))
    // window.addEventListener("keyup", this.validatePassword);
// favicon
  },
  methods: {
    init() {
      const that = this
      that.$refs.complexPassword.ok = () => {
        that.validatePassword()
      }
      that.$refs.complexPassword.cancel = () => {
        that.logout()
      }
    },
    validatePassword(event) {
      if (event && event.keyCode !== 13) { return false }
      const that = this
      that.$validator.validateAll({
        currentPassword: that.currentPassword,
        newPassword: that.newPassword,
        repeatNewPassword: that.repeatNewPassword,
      }).then(result => {
        if (result) {
          // 两次密码一致
          if (that.newPassword != that.repeatNewPassword) {
            that.errorText = 'The new password does not match the repeated new password';
            return;
          } else {
            that.errorText = '';
          }
          // 校验密码的复杂度
          let regExpPassword = new RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!@#$%^&*-])[A-Za-z\\d!@#$%^&*-]{8,}$")
          if (!regExpPassword.test(that.newPassword)) {
            that.errorText = this.$t('t.newPasswordMustBe');
            return;
          } else {
            that.errorText = '';
          }

          let token = localStorage.getItem('Authorization')
          request({
            method: 'post',
            url: 'api/dashboard/app/user/changePassword?access_token=' + token,
            data: {
              old_password: that.currentPassword,
              new_password: that.newPassword
            }
          }).then(res => {
            if(res.data.code === "10000") {
              that.$message({
                type: 'success',
                message: res.data.msg
              })
              setTimeout(() => {
                that.logout()
              }, 200);
            } else {
              // 90013 Original password mismatch
              // 80002 User does not exist
              // 80030 Password changed fail
              // 10000 Success
              if(res) {
                that.$message({
                  type: 'warn',
                  message: res.data.msg
                })
              }
            }
          })
        }
      })
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    logout () {
      let token = localStorage.getItem('Authorization')
      request({
        method: 'delete',
        url: 'api/dashboard/logout?access_token=' + token,
      }).then(res => {
        localStorage.clear();
        location.href = "/auth/login";
      })
    },
  },
  components: {
    multipleMerchant
  }
};
</script>

<style lang="scss">
@import "sass/main";

body {
  height: 100%;
  #app {
    height: 100%;

    .logined-mask {
      background-color: #333333;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 2;
      opacity: 0.4;
    }
    .change-password-show {
      display: flex!important;
      align-items: center!important;
      justify-content: center!important;
      .modal-dialog {
        max-width: 400px;
      }
      .modal-body {
        padding-bottom: 0;
      }
      .modal-content {
        width: 400px;
      }
    }
  }
  .login-eye-password {
    position: absolute;
    top: 2px;
    right: 20px;
    width: 25px;
    cursor: pointer;
    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
